module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 8e-05","quantity":0},{"color":"#9dc4b5","label":" 8e-05- 0.31443","quantity":0.00314},{"color":"#e6efc3","label":" 0.31443- 0.90789","quantity":0.00908},{"color":"#ffe89e","label":" 0.90789- 1.77444","quantity":0.01774},{"color":"#f5af7f","label":" 1.77444- 3.12905","quantity":0.03129},{"color":"#ed6d32","label":" 3.12905- 12.80407","quantity":0.12804}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/maize_MME_1981_2016_lcr_80.json
// module id = 1uLC
// module chunks = 171